import { Injectable } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { Purchases } from '@revenuecat/purchases-js';
import { ArmyBuilderConfig, HttpClientWithInFlightCache, SettingsService } from 'army-builder-shared';
import { catchError, filter, map, shareReplay, switchMap } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class SubscriptionService {
    public userHasAccess$ = this.settingsService.login$.pipe(
        map((l) => {
            return l.user?.roles?.includes('app_subscriber') || l.user?.roles?.includes('app_subscriber_annual');
        })
    );
    userHasAccess = toSignal(this.userHasAccess$);

    public newCustomer$ = this.settingsService.login$.pipe(
        map((l) => {
            return Object.keys(l.user?.entitlements ?? {}).length === 0;
        })
    );

    public userRoles$ = this.settingsService.login$.pipe(
        map((l) => {
            return l.user?.roles;
        })
    );

    public freeTrial$ = this.settingsService.login$.pipe(
        map((l) => {
            return l.user?.roles?.includes('app_free_trial');
        })
    );

    public expiry$ = this.settingsService.login$.pipe(
        map((l) => {
            const expiry = new Date(l.user?.entitlements?.all_access?.expires_date).getTime() || 0;

            if (expiry === 0) {
                return null;
            }
            return new Date(expiry);
        })
    );

    public hasExpired$ = this.expiry$.pipe(
        map((expiry) => {
            return expiry && expiry < new Date();
        })
    );

    public subStatus$ = this.settingsService.login$.pipe(
        filter((x) => x.user),
        switchMap((login) => {
            const user = login.user;
            if (user?.roles?.includes('app_admin')) {
                // return of('active');
            }

            return this.http
                .get(this.config.apiBaseUrl + '/user/subscription/status', {
                    responseType: 'text',
                    withCredentials: true,
                    requiresLogin: true
                })
                .pipe(
                    catchError((_err) => 'inactive'),
                    shareReplay(1)
                );
        })
    );

    constructor(
        private http: HttpClientWithInFlightCache,
        private settingsService: SettingsService,
        private config: ArmyBuilderConfig
    ) {}

    async checkSubscriptionStatus() {
        try {
            console.log('Checking subscription status');
            const customerInfo = await Purchases.getSharedInstance().getCustomerInfo();
            console.log({ customerInfo });
            // access latest customerInfo
        } catch (e) {
            // Handle errors fetching customer info
        }
    }
}
